var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"components-layout-demo-top-side-2"}},[_c('el-container',[_c('el-header',{style:({ padding: 0, 'z-index': 10 })},[_c('Headers')],1),_c('el-container',{staticStyle:{"background":"#f0f2f5"}},[_c('Aside'),_c('AppMain')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }